module.exports = __webpack_public_path__ + "static/media/Next.8376cb8d.svg";